import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import git from '../assets/git.png';
import html from '../assets/html.png';
import css from '../assets/css.png';
import javascript from '../assets/javascript.png';
import node from '../assets/node.png';
import c from '../assets/c.png';
import springboot from '../assets/springboot.png';

import about01 from '../assets/about01.png';
import about02 from '../assets/about02.png';
import about03 from '../assets/about03.png';

import profile from '../assets/profile-2.png';
import circle from '../assets/circle.svg';

import donate from '../assets/donate.png'

const images = {
    email,
    mobile,
    git,
    html,
    css,
    javascript,
    node,
    c,
    springboot,
    about01,
    about02,
    about03,
    profile,
    circle,
    donate
}

export default images;